import {Component, ViewChild} from "@angular/core";
import {IServerService} from "../../../../../domain/server/IServerService";
import {WaitingPopupComponent} from "../../../generic/popup/waitingPopup/waitingPopup";

@Component({
    selector: 'admin-webmaster-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class AdminWebmasterPresentationComponent {

    private serverService:IServerService;

    @ViewChild(WaitingPopupComponent) waitingPopupComponent:WaitingPopupComponent;
    public waitingMessage:string = "Initialisation du serveur";
    public successMessage:string = "Serveur initialisé";
    public errorMessage:string = "Erreur durant l'initialisation du serveur";

    constructor(serverService: IServerService) {
        this.serverService = serverService;
    }

    public initialize(){
        this.waitingPopupComponent.Open();
        this.serverService.Initialize().then(() => {
            this.waitingPopupComponent.Done(true);
        }).catch(err => {
            this.waitingPopupComponent.Done(false);
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/webmaster/presentation/presentation.ts